import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ResultsFooterWrapper = styled.footer`
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: ${Spacing.S16} ${Spacing.S8};
  border-top: 1px solid ${Color.Grey150};
  border-radius: 0 0 ${DefaultValue.BorderRadius} ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey100};
`

export const ShortcutItem = styled.li`
  display: flex;
  align-items: center;
`

export const ShortcutLabelWrapper = styled.div`
  margin-left: ${Spacing.S8};
`
